import { ArrowRightIcon } from '@/assets/ArrowRight';

/**
 * Признак «строку можно изменить»: нажатие открывает шторку.
 *
 * Не кнопка — нажимается вся строка целиком, поэтому своего обработчика и
 * фокуса у шеврона нет. Стоит у всех редактируемых строк, в том числе ещё не
 * заполненных: тогда рядом остаётся зелёное «Указать». У телефона вместо него
 * зелёный карандаш (EditPencilIcon): смена номера — единственное действие
 * здесь, которое требует подтверждения кодом, и выделяется намеренно.
 */
export const EditChevron = () => (
  <span aria-hidden className="flex shrink-0 items-center">
    <ArrowRightIcon className="text-text-icon-tertiary" />
  </span>
);
